import { type CheckboxProps } from '@/app/components/forms/checkbox';
import ThailandDistrict from '@/app/components/shared/dealer/utils/json/thailand-district.json';
import ThailandProvince from '@/app/components/shared/dealer/utils/json/thailand-province.json';

export enum SearchType {
  NATURAL = 'natural',
  SUGGEST = 'suggest',
  CURRENT_LOCATION = 'current-location',
}

export const DEALER_META_DATA = {
  TITLE: 'ค้นหาโชว์รูมและศูนย์บริการอีซูซุ',
  DESCRIPTION:
    'ค้นหาโชว์รูม ศูนย์บริการ ศูนย์บริการตัวถังและสีใกล้บ้านคุณได้ที่นี่ ค้นหาจากประเภท ชื่อผู้จำหน่าย จังหวัด เขต หรือเลขไปรษณีย์',
  DEFAULT_SUFFIX: {
    cv: 'ISUZU TRUCKS Thailand Official',
    lcv: 'อีซูซุประเทศไทย Isuzu Thailand Official',
  },
};

export const MAP_DEFAULT = {
  CENTER: { lat: 13.7625534, lng: 100.572413 },
  ZOOM: 5,
  ZOOM_IN: 13,
  ZOOM_SELECTED_DEALER: 16,
};

export const DEALER_DEFAULT_VALUE = {
  NAME: 'โชว์รูมและศูนย์บริการ',
  ADDRESS: 'ไม่มีข้อมูล',
  LOCATION_DENIED: {
    title: 'การเข้าถึงตำแหน่งถูกปฏิเสธ',
    description: 'กรุณาอนุญาตการเข้าถึงตำแหน่ง',
  },
};

export const DEALER_MY_ISUZU_APPOINTMENT = 'https://m.isuzu-tis.com/sappt';

export const THAILAND_LOCATIONS = [...ThailandProvince, ...ThailandDistrict];

export const EARTH_RADIUS = 6371;
export const NEARBY_RADIUS = 20;
export const NEARBY_RADIUS_RANGE = [8, 15, 20];

export enum DEALER_SEARCH_KEY {
  Source = 'source',
  ServiceType = 'service-type',
  Showroom = 'showroom',
  VehicleType = 'vehicle-type',
  Service = 'service',
  General = 'general',
  BodyPaint = 'body-paint',
  ChangeTire = 'change-tire',
  Overhaul = 'overhaul',
  BusinessDay = 'business-day',
  Weekdays = 'weekdays',
  Saturday = 'sat',
  Sunday = 'sun',
  Lat = 'lat',
  Lng = 'lng',
  Q = 'q',
  Tab = 'tab',
  Bound = 'bound',
}

export const DEALER_SERVICE_TARGET_KEYS = [
  DEALER_SEARCH_KEY.Service,
  DEALER_SEARCH_KEY.ChangeTire,
  DEALER_SEARCH_KEY.Overhaul,
];

export const DEALER_SCOPE_ADVANCED_SEARCH = [
  DEALER_SEARCH_KEY.VehicleType,
  DEALER_SEARCH_KEY.ServiceType,
  DEALER_SEARCH_KEY.Showroom,
  DEALER_SEARCH_KEY.Service,
  DEALER_SEARCH_KEY.BodyPaint,
  DEALER_SEARCH_KEY.BusinessDay,
];

export const DEALER_TYPES = [
  {
    id: DEALER_SEARCH_KEY.Showroom,
    label: 'โชว์รูม',
    icon: 'IconStore',
  },
  {
    id: DEALER_SEARCH_KEY.Service,
    label: 'ศูนย์บริการ',
    icon: 'IconBuild',
  },
  {
    id: DEALER_SEARCH_KEY.BodyPaint,
    label: 'ศูนย์บริการตัวถัง / สี',
    icon: 'IconColors',
  },
];

export interface AdvancedSearch {
  id: string;
  label: string;
  checked?: boolean;
  icon?: string;
  description?: string;
  options?: CheckboxProps['options'];
}

export const ADVANCED_SEARCH: AdvancedSearch[] = [
  {
    id: DEALER_SEARCH_KEY.Showroom,
    label: 'โชว์รูม',
    checked: false,
    icon: 'IconStore',
  },
  {
    id: DEALER_SEARCH_KEY.Service,
    label: 'ศูนย์บริการ',
    icon: 'IconBuild',
    checked: false,
    description: 'บริการพิเศษ',
    options: [
      {
        label: 'เปลี่ยนยาง',
        name: DEALER_SEARCH_KEY.ChangeTire,
        checked: false,
      },
      {
        label: 'โอเวอร์ฮอล์',
        name: DEALER_SEARCH_KEY.Overhaul,
        checked: false,
      },
    ],
  },
  {
    id: DEALER_SEARCH_KEY.BodyPaint,
    label: 'ศูนย์บริการตัวถัง / สี',
    checked: false,
    icon: 'IconColors',
  },
  {
    id: DEALER_SEARCH_KEY.BusinessDay,
    label: 'วันทำการ',
    icon: 'IconCalendarMonth',
    options: [
      {
        label: 'จันทร์ - ศุกร์',
        name: DEALER_SEARCH_KEY.Weekdays,
        checked: false,
      },
      {
        label: 'เสาร์',
        name: DEALER_SEARCH_KEY.Saturday,
        checked: false,
      },
      {
        label: 'อาทิตย์',
        name: DEALER_SEARCH_KEY.Sunday,
        checked: false,
      },
    ],
  },
  {
    id: DEALER_SEARCH_KEY.VehicleType,
    label: 'ประเภทรถ',
    icon: 'IconCar',
    options: [
      {
        label: 'รถปิกอัพ และรถอเนกประสงค์',
        name: 'lcv',
        checked: false,
      },
      {
        label: 'รถบรรทุก',
        name: 'cv',
        checked: false,
      },
    ],
  },
];
